import { ImportedPatientMappingResponse } from "@/Common/Api/ExternalCommunications/Dto/ImportedPatientMappingResponse";
import { SearchIndividualResult } from "@/Common/Api/Individuals/Dto/SearchIndividualResult";
import { FindPatientDuplicateRequest } from "@/Common/Api/Patient/Dto/FindPatientDuplicateRequest";
import { ExternalPatientImportAdvancedSearchRenderer } from "@/Common/Components/Import/ExternalPatientImportAdvancedSearchRenderer";
import { PatientImportHandler } from "@/Common/Components/Import/PatientImportHandler";
import { IImportablePatient } from "@/Common/Models/Patient/IPatient";
import { Person } from "@/Common/Models/Person/Person";

class ThirdPartyPatientImportHandler extends PatientImportHandler {
    private importedPatients: ImportedPatientMappingResponse[];

    constructor(importedPatients: ImportedPatientMappingResponse[]) {
        super();
        this.importedPatients = importedPatients;
    }

    public renderAdvancePatientSearch(foundPatient: Person, patientInfoForHighlight: IImportablePatient, className?: string, index?: number, onSelect?: (patient: Person) => void): JSX.Element {
        const isImportable = this.isImportable();
        return ExternalPatientImportAdvancedSearchRenderer.render(foundPatient, patientInfoForHighlight.toTransferable(), isImportable, className, index, onSelect);
    }

    public isImportable(): boolean {
        return true; // a Myle patient can be linked to multiple external patients; always allow import/link
    }

    public async getDuplicatePatients(healthCardInfo: FindPatientDuplicateRequest): Promise<SearchIndividualResult[]> {
        const duplicatePatientIds = await super.getDuplicatePatients(healthCardInfo);
        return duplicatePatientIds.filter(duplicate => !this.isPatientImported(duplicate.ContactFacetId));
    }

    private isPatientImported(contactFacetId: string): boolean {
        return this.importedPatients.some(p => p.InternalPatientId === contactFacetId);
    }
}

export { ThirdPartyPatientImportHandler };
